import { ApplicationFormField } from "@prisma/client";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export function useApplicationFormFieldMutation() {
  return useMutation<
    ApplicationFormField,
    null,
    {
      applicationId: string;
      formInstanceId: string;
      name: string;
      value: string;
      type: string;
    },
    () => void
  >(({ applicationId, formInstanceId, name, value, type }) =>
    axios.post(
      `/api/application/${applicationId}/form/${formInstanceId}/field`,
      {
        name,
        value,
        type,
      }
    )
  );
}
